import { Component } from '@angular/core';

@Component({
  selector: 'fallback',
  template: 'This app is not yet integrated into umoji',
})

export class FallbackComponent {
}
